import React, { useState } from 'react'
import Modal from '../../modal'
import CloseSVG from '../../../../assets/svg/close.svg'
import { formValidation } from '../../../../utils/functions'
import { useForm } from 'react-hook-form'
import DOMPurify from 'dompurify'
import Button from '../../../button'
import FormTextArea from '../../../form-textarea'
import { useAddBulkQuery } from '../../../../redux/human-resources/hook/queries'
import FormInput from '../../../form-input'
import AsyncSelect from 'react-select/async'
import { employees as employeeAPI } from '../../../../api/employees'

const AddBulkQuery = ({ isOpen, setBulkQuery }) => {
  const {
    register,
    handleSubmit,
    formState: { isValid },
    errors,
  } = useForm({
    mode: 'onChange',
  })
  const [query, setQuery] = useState('')
  const [employees, setEmployees] = useState([])

  const { mutateAsync: addBulkQuery, isLoading: addQueryloading } =
    useAddBulkQuery()

  const loadOptions = (inputValue) =>
    new Promise((resolve) => {
      employeeAPI
        .getEmployees({
          limit: 20,
          statusFilter: -1,
          search: inputValue,
          page: 1,
        })
        .then((response) => {
          let data = []

          response.data.forEach((item) => {
            data.push({
              label: `${item.first_name} ${item.last_name} | ${item.mobile} | ${item.email}`,
              value: item.id,
            })
          })

          resolve(data)
        })
        .catch((err) => {
          resolve([])
        })
    })

  const submitForm = async (data) => {
    const query = DOMPurify.sanitize(data?.query)
    const subject = DOMPurify.sanitize(data?.subject)

    if (employees.length === 0) {
      dispatch(setAlert(true, 'info', 'Select at least one employee'))
      return
    }
    let employeeArrays = []

    employees.forEach((item) => {
      employeeArrays.push(item.value)
    })

    let employee_ids = employeeArrays

    let payload = {
      subject,
      employee_ids: employee_ids,
      query,
    }

    await addBulkQuery(payload).then((response) => {
      setQuery('')
      setBulkQuery(false)
    })
  }

  return (
    <>
      <Modal
        scrollable={true}
        className='!max-w-[800px] !rounded-none'
        isOpen={isOpen}
        centered={true}
      >
        <div className='flex flex-col gap-4 overflow-auto p-3'>
          <form className='form pb-4' onSubmit={handleSubmit(submitForm)}>
            <div className='flex flex-row justify-between items-center'>
              <span className='header-4'>Send Query To Bulk Query</span>
              <div
                className='cursor-pointer'
                onClick={() => {
                  setBulkQuery(false)
                }}
              >
                <img src={CloseSVG} alt='close' />
              </div>
            </div>
            <div className='flex flex-col'>
              <div style={{ position: 'relative', maxHeight: '270px' }}>
                <label className='text-[13px] leading-[23px] font-normal text-color-gray mb-1'>
                  Add Employees
                </label>
                <AsyncSelect
                  isMulti
                  cacheOptions
                  defaultOptions
                  className='text-[13px]'
                  loadOptions={loadOptions}
                  onChange={(options) => setEmployees(options)}
                  classNamePrefix='mySelect'
                />
              </div>
              <div className='w-full mt-3'>
                <FormInput
                  label='Query Subject'
                  name='subject'
                  type='text'
                  placeholder={'Enter query subject'}
                  inputRef={register(formValidation('text', true))}
                  readOnly={addQueryloading}
                  error={errors.subject}
                  className={'!bg-white'}
                  errorMessage={errors.subject && errors.subject.message}
                />
              </div>
              <div>
                <FormTextArea
                  label={'Query'}
                  name='query'
                  type='text'
                  defaultValue={query}
                  onInput={(e) => {
                    setQuery(e.target.value)
                  }}
                  placeholder={'Enter the query here'}
                  inputRef={register(formValidation('text', true))}
                  readOnly={addQueryloading}
                  error={errors.query}
                  errorMessage={errors.query && errors.query.message}
                />
              </div>
            </div>
            <div className='w-full mt-[20px]'>
              <Button
                text='Send Query'
                type='submit'
                disabled={!isValid}
                loading={addQueryloading}
              />
            </div>
          </form>
        </div>
      </Modal>
    </>
  )
}

export default AddBulkQuery
